import { render, staticRenderFns } from "./ParticipantsSavings.vue?vue&type=template&id=6ef7523c"
import script from "./ParticipantsSavings.vue?vue&type=script&lang=js"
export * from "./ParticipantsSavings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports